import React from "react";
const Chart = () => {
  return (
    <>
      <section className="chartSection padSection text-center">
        <div className="container">
          <h2>Coinmarketcap Data Coming Soon</h2>
          <img src="./images/chart.png" className="img-responsive" />
        </div>
      </section>
    </>
  );
};
export default Chart;